<template>
  <div class="orderBox">
    <div class="form-title">证件信息及资料</div>
    <div class="form-title level2">投保人证件</div>
    <FormItem label="身份证头像面">
      <uploadNew v-model="formData.idcardHead1" @show="openEye(formData, 'idcardHead1', 1)" :disabled="disabled" />
    </FormItem>
    <FormItem label="身份证国徽面" :label-width="160">
      <uploadNew v-model="formData.idcardBack1" @show="openEye(formData, 'idcardBack1', 1)" :disabled="disabled" />
    </FormItem>
    <FormItem label="港澳通行证/护照头像面" :label-width="160">
      <uploadNew v-model="formData.passportHead1" @show="openEye(formData, 'passportHead1', 1)" :disabled="disabled" />
    </FormItem>
    <FormItem label="港澳通行证反面">
      <uploadNew v-model="formData.passportBack1" @show="openEye(formData, 'passportBack1', 1)" :disabled="disabled" />
    </FormItem>

    <div class="form-title level2">受保人证件</div>
    <FormItem label="身份证头像面">
      <uploadNew v-model="formData.idcardHead2" @show="openEye(formData, 'idcardHead2', 2)" :disabled="disabled" />
    </FormItem>
    <FormItem label="身份证国徽面" :label-width="160">
      <uploadNew v-model="formData.idcardBack2" @show="openEye(formData, 'idcardBack2', 2)" :disabled="disabled" />
    </FormItem>
    <FormItem label="港澳通行证/护照头像面" :label-width="160">
      <uploadNew v-model="formData.passportHead2" @show="openEye(formData, 'passportHead2', 2)" :disabled="disabled" />
    </FormItem>
    <FormItem label="港澳通行证反面">
      <uploadNew v-model="formData.passportBack2" @show="openEye(formData, 'passportBack2', 2)" :disabled="disabled" />
    </FormItem>
    <!-- 投保关系为孙子女 -->
    <FormItem label="出生证明/户口本照片" :label-width="160" v-if="['30', '31'].includes(formData.insurce.relation)">
      <uploadNew v-model="formData.householdRegister2" @show="openEye(formData, 'householdRegister2', 2)" :disabled="disabled" />
    </FormItem>
    <!-- 投保关系为配偶 -->
    <FormItem label="结婚证" :label-width="160" v-if="formData.insurce.relation == '4'">
      <uploadNew v-model="formData.marriageCertificate2" @show="openEye(formData, 'marriageCertificate2', 2)" :disabled="disabled" />
    </FormItem>

    <div class="form-title level2">其他资料</div>
    <FormItem label="其他资料" class="full">
      <uploadNew v-model="formData.other" @show="openEye(formData, 'other', 99)" :muti="true" :disabled="disabled" />
    </FormItem>
    <validUserName ref="validUserNameRef" @success="(...params) => openEye(...params)" />
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import uploadNew from '@/components/commons/maskUploadNew';
import validUserName from '@/components/commons/validUserName';
export default {
  mixins: [common],
  components: { uploadNew, validUserName },
  props: ['formData', 'disabled'],
  data() {
    return {
      userList: []
    };
  },
  methods: {
    openEye(row, code, customerType) {
      let cardType = {
        'idcardHead1': 'idcard_head',
        'idcardBack1': 'idcard_back',
        'passportHead1': 'passport_head',
        'passportBack1': 'passport_back',
        'idcardHead2': 'idcard_head',
        'idcardBack2': 'idcard_back',
        'passportHead2': 'passport_head',
        'passportBack2': 'passport_back',
        'householdRegister2': 'household_register',
        'marriageCertificate2': 'marriage_certificate'
      }
      if (!row['validName' + code]) {
        this.$refs.validUserNameRef.open(row, code, customerType);
        return;
      }
      if (!row['eyeShow' + code]) {
        this.descrypt(
          {
            customerType: customerType,
            cardType: cardType[code],
            query: row.id,
            operationFunction: 3,
            operationType: 14
          },
          row,
          code
        ).then(() => {
          this.$set(row, 'eyeShow' + code, true);
        });
      }
    },
  }
};
</script>
<style lang="scss" scoped></style>
